import React from 'react';
import Routers from './Routes/AuthRoutes';
import { ToastContainer } from "react-toastify";
import { AuthProvider, AuthInit } from 'Utils/Hooks/useAuth';
import CustomizerProvider from 'Core/Helper/Customizer/CustomizerProvider';
import AnimationThemeProvider from 'Core/Helper/AnimationTheme/AnimationThemeProvider';
import UserProvider from 'Core/Helper/User/UserProvider';
import ReportProvider from 'Core/Helper/Report/ReportProvider';
import ProductProvider from 'Core/Helper/Product/ProductProvider';

const App = () => (
  <div className='App'>
    <CustomizerProvider>
      <AnimationThemeProvider>
        <AuthProvider>
          <AuthInit>
            <UserProvider>
              <ProductProvider>
                <ReportProvider>
                  <Routers />
                  <ToastContainer />
                </ReportProvider>
              </ProductProvider>
            </UserProvider>
          </AuthInit>
        </AuthProvider>
      </AnimationThemeProvider>
    </CustomizerProvider>
  </div>
);

export default App;
